import type { OrderAttribute } from "@magento/types";
import { IOrderDataTypeEnum, IOrderInputTypeEnum } from "@magento/types";

export const getOrderAttributesWithZipCodeResponseMock = [
  {
    code: "zip_code",
    placement: "billingaddress_after",
    label: "zip code for test",
    input_type: IOrderInputTypeEnum.Text,
    data_type: IOrderDataTypeEnum.Text,
    is_required: false,
    min_length: 0,
    max_length: 0,
    validate_regex: "",
    value: "",
    description: "ZIP Code",
    placeholder: "ZIP Code",
    sort_order: 0,
  },
] as const satisfies OrderAttribute[];
